<template>
  <div>
    <h4 for="">{{ label }}</h4>
    <v-switch v-model="valor" :label="`${valor}`"></v-switch>
    <p v-if="descripcion">{{ descripcion }}</p>
  </div>
</template>
<script>
import { onBeforeMount, ref, watch } from '@vue/composition-api'
export default {
  props: {
    label: {
      type: String,
      default: 'Tipo valor boolean',
    },
    descripcion: {
      type: String,
      default: 'Descripcion',
    },
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, contex) {
    const valor = ref(false)
    onBeforeMount(() => {
      valor.value = props.value
    })

    const returnDato = () => {
      contex.emit('input', valor.value)
    }
    watch(valor, () => {
      returnDato()
    })
    return {
      valor,
    }
  },
}
</script>